import React from 'react';
import { Button } from 'flowbite-react';
import { AiOutlineCalendar } from 'react-icons/ai';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	onClick: () => void;
}

const InterviewsTopBar = ({ onClick }: Props) => {
	const { hasActiveMeeting, allowUserToScheduleMeeting } = useUserContext();

	return (
		<div className="flex justify-between items-center py-2 pt-6 sm:pt-9 border-b dark:border-[#555770] border-solid">
			<div className="text-2xl font-semibold">Assessments</div>
			{/* <div>
				{allowUserToScheduleMeeting || hasActiveMeeting ? (
					<Button color="purplePlaced" disabled={hasActiveMeeting} onClick={onClick}>
						<AiOutlineCalendar className="mr-2" />
						Schedule Tech Round
					</Button>
				) : null}
			</div> */}
		</div>
	);
};

export default InterviewsTopBar;
